<script setup>
import { computed } from 'vue';
import { useMapGetter } from 'dashboard/composables/store';
import BaseBubble from './Base.vue';
import TextBubble from './Text/Index.vue';
import TemplatePreview from 'dashboard/components-next/template-preview/TemplatePreview.vue';
import { useMessageContext } from '../provider.js';

// Mensagem enviada como template da API oficial (campanha, agendamento ou
// envio manual): renderiza o mockup real — header, corpo, rodapé e botões —
// pra atendente ver o que o cliente recebeu, não só o texto do corpo.
const { additionalAttributes, inboxId } = useMessageContext();

const templatesGetter = useMapGetter('inboxes/getFilteredWhatsAppTemplates');

const templateParams = computed(
  () => additionalAttributes.value?.templateParams || null
);

// O template sincronizado da caixa (mesma fonte do picker). Se sumiu de lá
// (apagado/renomeado na Meta), cai no TextBubble normal.
const template = computed(() => {
  const params = templateParams.value;
  if (!params?.name) return null;
  const templates = templatesGetter.value(Number(inboxId.value)) || [];
  return (
    templates.find(
      item =>
        item.name === params.name &&
        (!params.language || item.language === params.language)
    ) || null
  );
});

const variables = computed(() => ({
  ...(templateParams.value?.processedParams?.body || {}),
}));
</script>

<template>
  <!--
    A bolha continua AZUL como qualquer mensagem que nós enviamos — era o
    `!bg-transparent` daqui que a deixava sem fundo. No tema escuro ninguém
    notava (fundo do app escuro, texto branco legível); no tema claro o corpo
    do template, que herda `[&_.prose]:!text-white` da variante do agente,
    virava branco sobre branco. Como o preview mora dentro da bolha, o card
    dele fica transparente e os elementos de apoio (rodapé, botões, filetes)
    passam para tons de branco.
  -->
  <BaseBubble
    v-if="template"
    class="!p-0 overflow-hidden [&_.template-preview>*]:!bg-transparent [&_.template-preview>*]:!max-w-none [&_.text-n-slate-11]:!text-white/70 [&_.text-n-blue-11]:!text-white [&_.border-n-strong]:!border-white/25 [&_.divide-n-strong]:!divide-white/25"
    data-bubble-name="whatsapp-template"
  >
    <TemplatePreview
      :template="template"
      :variables="variables"
      platform="whatsapp"
    />
  </BaseBubble>
  <TextBubble v-else />
</template>
